import { Button } from "@cmsgov/ds-medicare-gov";
import React, { useContext } from "react";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../../app/contexts/Analytics/types";
import { AppContext } from "../../../app/store";
import { useTranslate } from "../../../helpers";

interface PlanTypePageActionsProps {
  findPlansButtonText: string;
  handleGoBack: () => void;
}

export const PlanTypeStepActions: React.FunctionComponent<PlanTypePageActionsProps> = ({
  findPlansButtonText,
  handleGoBack,
}) => {
  const { dispatch } = useContext(AppContext);
  const t = useTranslate();
  const goBackText = t("coverage_selector.go_back");
  return (
    <>
      <Button
        variation="solid"
        className="mct-c-coverage-selector-v2__start-button"
        data-testid="start-button"
        type="submit"
      >
        {findPlansButtonText}
      </Button>
      <Button
        variation="ghost"
        className="mct-c-coverage-selector-v2__go-back-button"
        type="button"
        onClick={() => {
          handleGoBack();
          dispatch({
            type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
            settings: {
              button: {
                buttonStyle: AnalyticsButtonStyle.TRANSPARENT,
                buttonType: AnalyticsButtonType.BUTTON,
                text: goBackText,
              },
            },
          });
        }}
      >
        {goBackText}
      </Button>
    </>
  );
};
